import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/* eslint-disable max-len, react/prop-types */
var Ellipsis = function Ellipsis(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: "36",
    height: "36",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Ellipsis Icon"
    }), /*#__PURE__*/_jsx("path", {
      "aria-hidden": "true",
      d: "M25 20a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z",
      fillRule: "evenodd"
    })]
  });
};

export default Ellipsis;